<template>
  <floating-window name="image" left="0" top="100" defaultVisible="true">
    current image<br>
    <img
      :src   ="currentImage"
      width  ="120"
    ><br>
    <el-button class="image-toggle" @click="clickHandler" >show map</el-button><br>
    {{ sliderModel }}%
    <el-slider
      :min    ="1"
      :max    ="300"
      @change ="emitImageSize"
      v-model ="sliderModel"
    />
    <div
      style="height: 100px; width: 100%; backgroundColor: #000;"
      @dragleave.prevent
      @dragover.prevent
      @drop.prevent="onDrop"
    >
      <input type="file" @change="selectFile">
    </div>
    <div>
      <div>
        <img
          v-for  ="(image, index) in imageList"
          :key   ="index"
          :src   ="image"
          width  ="90"
          @click ="changeCurrentImage(image)"
        >
      </div>
      <el-button @click="initializeList()">clear</el-button>
    </div>
  </floating-window>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ImageBoardUi',
  data () {
    return {}
  },
  computed: {
    sliderModel: {
      get () { return this.imageSize },
      set (value) { this.changeImageSize(value) }
    },
    imageVisible: {
      get () { return this.visible },
      set () { this.toggleVisible() }
    },
    ...mapGetters('imageBoard', [
      'imageList',
      'currentImage',
      'imageSize',
      'visible'
    ])
  },
  methods: {
    clickHandler () {
      this.toggleVisible()
    },
    onDrop (e) {
      const files = e.dataTransfer.files
      Object.keys(files).forEach(key => {
        if (files[key].type.indexOf('image') !== -1) {
          const fileReader  = new FileReader()
          fileReader.onload = e => { this.addImageToList(e.target.result) }
          fileReader.readAsDataURL(files[key])
        }
      })
    },
    selectFile (e) {
      const files = e.target.files
      Object.keys(files).forEach(key => {
        if (files[key].type.indexOf('image') !== -1) {
          const fileReader  = new FileReader()
          fileReader.onload = e => { this.addImageToList(e.target.result) }
          fileReader.readAsDataURL(files[key])
        }
      })
    },
    ...mapActions('imageBoard', [
      'addImageToList',
      'initializeList',
      'clearImageList',
      'changeCurrentImage',
      'changeImageSize',
      'toggleVisible',
      'emitImageSize'
    ])
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/image/controller/index.vue